function required(v, field) {
    return !!v || `${field} is required.`;
}

function maxLength(v, length, field) {
    return v.length <= length || `${field} must be less than ${length} characters.`;
}

function onlyNumber(v, field) {
    return /^\d+$/.test(v) || `${field} must be a number.`;
}

function validEmail(v, field) {
    return /.+@.+/.test(v) || `${field} must be valid.`;
}

function validWebsite(v, field) {
    return /^(https:\/\/)+(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/.test(v) || `${field} must be valid`;
}

function confirmPassword(v, field, password, confirm_password) {
    if (password.equals(confirm_password)) {
        return `${field} must be valid`;
    }
    return /.+@.+/.test(v) || `${field} must be valid.`;
}

export default {
    required,
    maxLength,
    onlyNumber,
    validEmail,
    validWebsite,
    confirmPassword
}